import React from 'react';
import PropTypes from 'prop-types';

export function Bold({ color, width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9999 12.75H4.87988C4.46988 12.75 4.12988 12.41 4.12988 12V4.5C4.12988 2.98 5.35988 1.75 6.87988 1.75H11.9999C15.0299 1.75 17.4999 4.22 17.4999 7.25C17.4999 10.28 15.0299 12.75 11.9999 12.75ZM5.61988 11.25H11.9999C14.2099 11.25 15.9999 9.46 15.9999 7.25C15.9999 5.04 14.2099 3.25 11.9999 3.25H6.87988C6.18988 3.25 5.62988 3.81 5.62988 4.5V11.25H5.61988Z"
        fill={color}
      />
      <path
        d="M14.3799 22.25H6.87988C5.35988 22.25 4.12988 21.02 4.12988 19.5V12C4.12988 11.59 4.46988 11.25 4.87988 11.25H14.3799C17.4099 11.25 19.8799 13.72 19.8799 16.75C19.8799 19.78 17.4099 22.25 14.3799 22.25ZM5.61988 12.75V19.5C5.61988 20.19 6.17988 20.75 6.86988 20.75H14.3699C16.5799 20.75 18.3699 18.96 18.3699 16.75C18.3699 14.54 16.5799 12.75 14.3699 12.75H5.61988Z"
        fill={color}
      />
    </svg>
  );
}
Bold.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
Bold.defaultProps = {
  color: '',
  width: '',
  height: '',
};

export function Italic({ color, width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.8799 3.75H9.61988C9.20988 3.75 8.87988 3.41 8.87988 3C8.87988 2.59 9.21988 2.25 9.62988 2.25H18.8799C19.2899 2.25 19.6299 2.59 19.6299 3C19.6299 3.41 19.2899 3.75 18.8799 3.75Z"
        fill={color}
      />
      <path
        d="M14.3801 21.75H5.12012C4.71012 21.75 4.37012 21.41 4.37012 21C4.37012 20.59 4.71012 20.25 5.12012 20.25H14.3701C14.7801 20.25 15.1201 20.59 15.1201 21C15.1201 21.41 14.7901 21.75 14.3801 21.75Z"
        fill={color}
      />
      <path
        d="M9.7501 21.75C9.6901 21.75 9.6301 21.74 9.5701 21.73C9.1701 21.63 8.9201 21.22 9.0201 20.82L13.5201 2.82001C13.6201 2.42001 14.0201 2.17001 14.4301 2.27001C14.8301 2.37001 15.0801 2.78001 14.9801 3.18001L10.4801 21.18C10.3901 21.52 10.0901 21.75 9.7501 21.75Z"
        fill={color}
      />
    </svg>
  );
}
Italic.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
Italic.defaultProps = {
  color: '',
  width: '',
  height: '',
};

export function Underline({ color, width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 21.75H5C4.59 21.75 4.25 21.41 4.25 21C4.25 20.59 4.59 20.25 5 20.25H19C19.41 20.25 19.75 20.59 19.75 21C19.75 21.41 19.41 21.75 19 21.75Z"
        fill={color}
      />
      <path
        d="M12 17.75C7.73 17.75 4.25 14.27 4.25 10V3C4.25 2.59 4.59 2.25 5 2.25C5.41 2.25 5.75 2.59 5.75 3V10C5.75 13.45 8.55 16.25 12 16.25C15.45 16.25 18.25 13.45 18.25 10V3C18.25 2.59 18.59 2.25 19 2.25C19.41 2.25 19.75 2.59 19.75 3V10C19.75 14.27 16.27 17.75 12 17.75Z"
        fill={color}
      />
    </svg>
  );
}
Underline.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
Underline.defaultProps = {
  color: '',
  width: '',
  height: '',
};
export function LeftAlign({ color, width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.0015 5.25H3.00146C2.59146 5.25 2.25146 4.91 2.25146 4.5C2.25146 4.09 2.59146 3.75 3.00146 3.75H21.0015C21.4115 3.75 21.7515 4.09 21.7515 4.5C21.7515 4.91 21.4115 5.25 21.0015 5.25Z"
        fill={color}
      />
      <path
        d="M12.4715 10.25H3.00146C2.59146 10.25 2.25146 9.91 2.25146 9.5C2.25146 9.09 2.59146 8.75 3.00146 8.75H12.4715C12.8815 8.75 13.2215 9.09 13.2215 9.5C13.2215 9.91 12.8915 10.25 12.4715 10.25Z"
        fill={color}
      />
      <path
        d="M21.0015 15.25H3.00146C2.59146 15.25 2.25146 14.91 2.25146 14.5C2.25146 14.09 2.59146 13.75 3.00146 13.75H21.0015C21.4115 13.75 21.7515 14.09 21.7515 14.5C21.7515 14.91 21.4115 15.25 21.0015 15.25Z"
        fill={color}
      />
      <path
        d="M12.4715 20.25H3.00146C2.59146 20.25 2.25146 19.91 2.25146 19.5C2.25146 19.09 2.59146 18.75 3.00146 18.75H12.4715C12.8815 18.75 13.2215 19.09 13.2215 19.5C13.2215 19.91 12.8915 20.25 12.4715 20.25Z"
        fill={color}
      />
    </svg>
  );
}
LeftAlign.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
LeftAlign.defaultProps = {
  color: '',
  width: '',
  height: '',
};
export function RightAlign({ color, width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.0015 5.25H3.00146C2.59146 5.25 2.25146 4.91 2.25146 4.5C2.25146 4.09 2.59146 3.75 3.00146 3.75H21.0015C21.4115 3.75 21.7515 4.09 21.7515 4.5C21.7515 4.91 21.4115 5.25 21.0015 5.25Z"
        fill="#292D32"
      />
      <path
        d="M21.0015 10.25H11.5315C11.1215 10.25 10.7815 9.91 10.7815 9.5C10.7815 9.09 11.1215 8.75 11.5315 8.75H21.0015C21.4115 8.75 21.7515 9.09 21.7515 9.5C21.7515 9.91 21.4115 10.25 21.0015 10.25Z"
        fill={color}
      />
      <path
        d="M21.0015 15.25H3.00146C2.59146 15.25 2.25146 14.91 2.25146 14.5C2.25146 14.09 2.59146 13.75 3.00146 13.75H21.0015C21.4115 13.75 21.7515 14.09 21.7515 14.5C21.7515 14.91 21.4115 15.25 21.0015 15.25Z"
        fill={color}
      />
      <path
        d="M21.0015 20.25H11.5315C11.1215 20.25 10.7815 19.91 10.7815 19.5C10.7815 19.09 11.1215 18.75 11.5315 18.75H21.0015C21.4115 18.75 21.7515 19.09 21.7515 19.5C21.7515 19.91 21.4115 20.25 21.0015 20.25Z"
        fill={color}
      />
    </svg>
  );
}
RightAlign.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
RightAlign.defaultProps = {
  color: '',
  width: '',
  height: '',
};
export function CenterAlign({ color, width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.0015 5.25H3.00146C2.59146 5.25 2.25146 4.91 2.25146 4.5C2.25146 4.09 2.59146 3.75 3.00146 3.75H21.0015C21.4115 3.75 21.7515 4.09 21.7515 4.5C21.7515 4.91 21.4115 5.25 21.0015 5.25Z"
        fill={color}
      />
      <path
        d="M16.7415 10.25H7.26147C6.85147 10.25 6.51147 9.91 6.51147 9.5C6.51147 9.09 6.85147 8.75 7.26147 8.75H16.7315C17.1415 8.75 17.4815 9.09 17.4815 9.5C17.4815 9.91 17.1515 10.25 16.7415 10.25Z"
        fill={color}
      />
      <path
        d="M21.0015 15.25H3.00146C2.59146 15.25 2.25146 14.91 2.25146 14.5C2.25146 14.09 2.59146 13.75 3.00146 13.75H21.0015C21.4115 13.75 21.7515 14.09 21.7515 14.5C21.7515 14.91 21.4115 15.25 21.0015 15.25Z"
        fill={color}
      />
      <path
        d="M16.7415 20.25H7.26147C6.85147 20.25 6.51147 19.91 6.51147 19.5C6.51147 19.09 6.85147 18.75 7.26147 18.75H16.7315C17.1415 18.75 17.4815 19.09 17.4815 19.5C17.4815 19.91 17.1515 20.25 16.7415 20.25Z"
        fill={color}
      />
    </svg>
  );
}
CenterAlign.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
CenterAlign.defaultProps = {
  color: '',
  width: '',
  height: '',
};
export function JustifiedAlign({ color, width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.0015 5.25H3.00146C2.59146 5.25 2.25146 4.91 2.25146 4.5C2.25146 4.09 2.59146 3.75 3.00146 3.75H21.0015C21.4115 3.75 21.7515 4.09 21.7515 4.5C21.7515 4.91 21.4115 5.25 21.0015 5.25Z"
        fill={color}
      />
      <path
        d="M21.0015 10.25H3.00146C2.59146 10.25 2.25146 9.91 2.25146 9.5C2.25146 9.09 2.59146 8.75 3.00146 8.75H21.0015C21.4115 8.75 21.7515 9.09 21.7515 9.5C21.7515 9.91 21.4115 10.25 21.0015 10.25Z"
        fill={color}
      />
      <path
        d="M21.0015 15.25H3.00146C2.59146 15.25 2.25146 14.91 2.25146 14.5C2.25146 14.09 2.59146 13.75 3.00146 13.75H21.0015C21.4115 13.75 21.7515 14.09 21.7515 14.5C21.7515 14.91 21.4115 15.25 21.0015 15.25Z"
        fill={color}
      />
      <path
        d="M21.0015 20.25H3.00146C2.59146 20.25 2.25146 19.91 2.25146 19.5C2.25146 19.09 2.59146 18.75 3.00146 18.75H21.0015C21.4115 18.75 21.7515 19.09 21.7515 19.5C21.7515 19.91 21.4115 20.25 21.0015 20.25Z"
        fill={color}
      />
    </svg>
  );
}
JustifiedAlign.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
JustifiedAlign.defaultProps = {
  color: '',
  width: '',
  height: '',
};

export function LinkOption({ color, width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5015 18.25H14.9915C14.5815 18.25 14.2415 17.91 14.2415 17.5C14.2415 17.09 14.5815 16.75 14.9915 16.75H16.5015C19.1215 16.75 21.2515 14.62 21.2515 12C21.2515 9.38 19.1215 7.25 16.5015 7.25H15.0015C14.5915 7.25 14.2515 6.91 14.2515 6.5C14.2515 6.09 14.5815 5.75 15.0015 5.75H16.5015C19.9515 5.75 22.7515 8.55 22.7515 12C22.7515 15.45 19.9515 18.25 16.5015 18.25Z"
        fill={color}
      />
      <path
        d="M9.00146 18.25H7.50146C4.05146 18.25 1.25146 15.45 1.25146 12C1.25146 8.55 4.05146 5.75 7.50146 5.75H9.00146C9.41146 5.75 9.75146 6.09 9.75146 6.5C9.75146 6.91 9.41146 7.25 9.00146 7.25H7.50146C4.88146 7.25 2.75146 9.38 2.75146 12C2.75146 14.62 4.88146 16.75 7.50146 16.75H9.00146C9.41146 16.75 9.75146 17.09 9.75146 17.5C9.75146 17.91 9.41146 18.25 9.00146 18.25Z"
        fill={color}
      />
      <path
        d="M16.0015 12.75H8.00146C7.59146 12.75 7.25146 12.41 7.25146 12C7.25146 11.59 7.59146 11.25 8.00146 11.25H16.0015C16.4115 11.25 16.7515 11.59 16.7515 12C16.7515 12.41 16.4115 12.75 16.0015 12.75Z"
        fill={color}
      />
    </svg>
  );
}
LinkOption.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
LinkOption.defaultProps = {
  color: '',
  width: '',
  height: '',
};
export function ImageOption({ color, width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
        fill={color}
      />
      <path
        d="M9 10.75C7.48 10.75 6.25 9.52 6.25 8C6.25 6.48 7.48 5.25 9 5.25C10.52 5.25 11.75 6.48 11.75 8C11.75 9.52 10.52 10.75 9 10.75ZM9 6.75C8.31 6.75 7.75 7.31 7.75 8C7.75 8.69 8.31 9.25 9 9.25C9.69 9.25 10.25 8.69 10.25 8C10.25 7.31 9.69 6.75 9 6.75Z"
        fill={color}
      />
      <path
        d="M2.67002 19.7001C2.43002 19.7001 2.19002 19.5801 2.05002 19.3701C1.82002 19.0301 1.91002 18.5601 2.26002 18.3301L7.19002 15.0201C8.27002 14.2901 9.76002 14.3801 10.74 15.2101L11.07 15.5001C11.57 15.9301 12.42 15.9301 12.91 15.5001L17.07 11.9301C18.13 11.0201 19.8 11.0201 20.87 11.9301L22.5 13.3301C22.81 13.6001 22.85 14.0701 22.58 14.3901C22.31 14.7001 21.84 14.7401 21.52 14.4701L19.89 13.0701C19.39 12.6401 18.54 12.6401 18.04 13.0701L13.88 16.6401C12.82 17.5501 11.15 17.5501 10.08 16.6401L9.75002 16.3501C9.29002 15.9601 8.53002 15.9201 8.02002 16.2701L3.09002 19.5801C2.96002 19.6601 2.81002 19.7001 2.67002 19.7001Z"
        fill={color}
      />
    </svg>
  );
}
ImageOption.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
ImageOption.defaultProps = {
  color: '',
  width: '',
  height: '',
};

export function BulletList({ color, width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19.25 4.4H6.75C6.28056 4.4 5.9 4.78056 5.9 5.25C5.9 5.71944 6.28056 6.1 6.75 6.1H19.25C19.7194 6.1 20.1 5.71944 20.1 5.25C20.1 4.78056 19.7194 4.4 19.25 4.4ZM19.25 11.15H6.75C6.28056 11.15 5.9 11.5306 5.9 12C5.9 12.4694 6.28056 12.85 6.75 12.85H19.25C19.7194 12.85 20.1 12.4694 20.1 12C20.1 11.5306 19.7194 11.15 19.25 11.15ZM19.25 17.9H6.75C6.28056 17.9 5.9 18.2806 5.9 18.75C5.9 19.2194 6.28056 19.6 6.75 19.6H19.25C19.7194 19.6 20.1 19.2194 20.1 18.75C20.1 18.2806 19.7194 17.9 19.25 17.9Z"
        fill="black"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M2.25 6.75C3.07843 6.75 3.75 6.07843 3.75 5.25C3.75 4.42157 3.07843 3.75 2.25 3.75C1.42157 3.75 0.75 4.42157 0.75 5.25C0.75 6.07843 1.42157 6.75 2.25 6.75Z"
        fill={color}
      />
      <path
        d="M2.25 13.5C3.07843 13.5 3.75 12.8284 3.75 12C3.75 11.1716 3.07843 10.5 2.25 10.5C1.42157 10.5 0.75 11.1716 0.75 12C0.75 12.8284 1.42157 13.5 2.25 13.5Z"
        fill={color}
      />
      <path
        d="M2.25 20.25C3.07843 20.25 3.75 19.5784 3.75 18.75C3.75 17.9216 3.07843 17.25 2.25 17.25C1.42157 17.25 0.75 17.9216 0.75 18.75C0.75 19.5784 1.42157 20.25 2.25 20.25Z"
        fill={color}
      />
    </svg>
  );
}
BulletList.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
BulletList.defaultProps = {
  color: '',
  width: '',
  height: '',
};

export function NumberList({ color, width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_21667_214735)">
        <path
          d="M8 7H20C20.55 7 21 6.55 21 6C21 5.45 20.55 5 20 5H8C7.45 5 7 5.45 7 6C7 6.55 7.45 7 8 7ZM20 17H8C7.45 17 7 17.45 7 18C7 18.55 7.45 19 8 19H20C20.55 19 21 18.55 21 18C21 17.45 20.55 17 20 17ZM20 11H8C7.45 11 7 11.45 7 12C7 12.55 7.45 13 8 13H20C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11ZM4.5 16H2.5C2.22 16 2 16.22 2 16.5C2 16.78 2.22 17 2.5 17H4V17.5H3.5C3.22 17.5 3 17.72 3 18C3 18.28 3.22 18.5 3.5 18.5H4V19H2.5C2.22 19 2 19.22 2 19.5C2 19.78 2.22 20 2.5 20H4.5C4.78 20 5 19.78 5 19.5V16.5C5 16.22 4.78 16 4.5 16ZM2.5 5H3V7.5C3 7.78 3.22 8 3.5 8C3.78 8 4 7.78 4 7.5V4.5C4 4.22 3.78 4 3.5 4H2.5C2.22 4 2 4.22 2 4.5C2 4.78 2.22 5 2.5 5ZM4.5 10H2.5C2.22 10 2 10.22 2 10.5C2 10.78 2.22 11 2.5 11H3.8L2.12 12.96C2.04 13.05 2 13.17 2 13.28V13.5C2 13.78 2.22 14 2.5 14H4.5C4.78 14 5 13.78 5 13.5C5 13.22 4.78 13 4.5 13H3.2L4.88 11.04C4.96 10.95 5 10.83 5 10.72V10.5C5 10.22 4.78 10 4.5 10Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_21667_214735">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
NumberList.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
NumberList.defaultProps = {
  color: '',
  width: '',
  height: '',
};

export function TableIcon({ color, width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M23.9745 2.922C23.9085 2.1495 23.2845 1.5 22.5 1.5H1.5C0.7155 1.5 0.0915 2.1495 0.0255 2.922H0V22.5C0 22.8978 0.158035 23.2794 0.43934 23.5607C0.720644 23.842 1.10218 24 1.5 24H22.5C22.8978 24 23.2794 23.842 23.5607 23.5607C23.842 23.2794 24 22.8978 24 22.5V2.922H23.9745ZM9 10.5V6H15V10.5H9ZM15 12V16.6245H9V12H15ZM7.5 6V10.5H1.5V6H7.5ZM1.5 12H7.5V16.6245H1.5V12ZM1.5 22.5V18H7.5V22.5H1.5ZM9 22.5V18H15V22.5H9ZM22.5 22.5H16.5V18H22.5V22.5ZM22.5 16.6245H16.5V12H22.5V16.6245ZM22.5 10.5H16.5V6H22.5V10.5Z"
        fill={color}
      />
    </svg>
  );
}
TableIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
TableIcon.defaultProps = {
  color: '',
  width: '',
  height: '',
};
export function FormattIcon({ activeColor, color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.93675 3.02517C6.47775 1.64717 4.52275 1.66217 4.08375 3.04717L0.0307496 15.8472C-0.0249296 16.0356 -0.00445257 16.2383 0.087778 16.4118C0.180009 16.5853 0.336627 16.7156 0.523961 16.7748C0.711295 16.8341 0.914384 16.8174 1.08956 16.7284C1.26474 16.6395 1.39802 16.4854 1.46075 16.2992L2.56175 12.8232H8.62175L9.78475 16.3102C9.81489 16.4048 9.86353 16.4925 9.92784 16.5682C9.99216 16.6439 10.0709 16.7061 10.1594 16.7511C10.2479 16.7961 10.3445 16.8231 10.4436 16.8305C10.5426 16.8379 10.6422 16.8256 10.7364 16.7942C10.8306 16.7628 10.9177 16.713 10.9925 16.6477C11.0674 16.5824 11.1285 16.5028 11.1723 16.4137C11.2162 16.3246 11.2419 16.2276 11.248 16.1285C11.2541 16.0293 11.2404 15.93 11.2077 15.8362L6.93775 3.02617L6.93675 3.02517ZM8.12175 11.3232L5.51375 3.50017L3.03675 11.3232H8.12175ZM14.3197 5.78617C15.2958 5.42669 16.3629 5.39823 17.3568 5.70517C18.121 5.94107 18.7895 6.41556 19.2644 7.0591C19.7394 7.70263 19.9956 8.48137 19.9958 9.28117V16.0732C19.9958 16.2721 19.9167 16.4628 19.7761 16.6035C19.6354 16.7442 19.4447 16.8232 19.2458 16.8232C19.0468 16.8232 18.8561 16.7442 18.7154 16.6035C18.5748 16.4628 18.4958 16.2721 18.4958 16.0732V15.3282C17.6464 15.9649 16.6785 16.4256 15.6487 16.6832C15.0696 16.8279 14.4603 16.7965 13.8991 16.5929C13.3379 16.3892 12.8503 16.0227 12.4987 15.5402C10.8437 13.2652 12.4687 10.0732 15.2827 10.0732H18.4958V9.28117C18.4958 8.29717 17.8548 7.42817 16.9148 7.13817C16.235 6.92832 15.5052 6.948 14.8377 7.19417L14.5957 7.28317C14.2831 7.39831 14.0003 7.58231 13.7683 7.82153C13.5364 8.06075 13.3612 8.34908 13.2557 8.66517L13.2077 8.81017C13.143 8.99642 13.0074 9.14965 12.8305 9.2367C12.6536 9.32376 12.4495 9.33762 12.2624 9.27531C12.0753 9.21299 11.9203 9.0795 11.8309 8.90373C11.7415 8.72797 11.7249 8.52407 11.7847 8.33617L11.8327 8.19117C12.0093 7.66175 12.3026 7.17881 12.6911 6.77809C13.0795 6.37737 13.5531 6.06912 14.0767 5.87617L14.3197 5.78617ZM18.4958 11.5732H15.2827C13.6957 11.5732 12.7787 13.3742 13.7127 14.6582C14.0697 15.1492 14.6927 15.3752 15.2847 15.2282C16.1864 15.0026 17.0288 14.5855 17.7548 14.0052L18.4958 13.4122V11.5732Z"
        fill={color}
      />
      <line
        x1="0.75"
        y1="19.25"
        x2="19.25"
        y2="19.25"
        stroke={activeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
FormattIcon.propTypes = {
  activeColor: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number,
};
FormattIcon.defaultProps = {
  activeColor: '#000000',
  color: '#000000',
  size: 20,
};
